<template>
    <TheModal class="sm nofh" @close="$emit('close')">
        <template v-slot:head>{{ item.name }}</template>

        <div class="d-flex justify-content-between mb-2">
            <span>Загрузка</span>
            <span>{{ item.current_loading + add | roundVolume }}/{{ item.max | roundVolume }} {{ item.unit | unit }}</span>
        </div>

        <vm-loading-level :loading="item.current_loading + add" :max="item.max" class="mb-4" style="height: 2rem; border-radius: 0;" />

        <volume-input placeholder="0" :value="add" :unit="item.unit" class="w-100 mb-4" @input="addManual" />

        <div class="d-flex flex-row mb-4">
            <button v-if="item.current_loading > 0" type="button" class="btn btn-lg btn-outline-primary text-nowrap flex-fill px-0 mr-1" @click="subMax">
                -{{ item.current_loading | roundVolume }}
            </button>

            <button v-if="item.current_loading > 0" type="button" class="btn btn-lg btn-outline-primary text-nowrap flex-fill px-0 mr-1" @click="subSmall">
                -{{ item.unit | unitSmallVolume }}
            </button>

            <button type="button" class="btn btn-lg btn-outline-primary text-nowrap flex-fill px-0 mr-1" @click="addSmall">
                +{{ item.unit | unitSmallVolume | roundVolume }}
            </button>

            <button type="button" class="btn btn-lg btn-outline-primary text-nowrap flex-fill px-0 mr-1" @click="addLarge">
                +{{ item.unit | unitLargeVolume | roundVolume }}
            </button>

            <button type="button" class="btn btn-lg btn-outline-primary text-nowrap flex-fill px-0" @click="addMax">
                <i class="tlm-icon-upload" />
            </button>
        </div>

        <button type="button" class="btn btn-lg-192 btn-primary" @click="submit">Применить</button>
    </TheModal>
</template>

<script>
import { round } from 'lodash'

import TheModal from '@/components/TheModal'
import VolumeInput from '@/components/VolumeInput'
import VmLoadingLevel from '@/components/VmLoadingLevel'

const unitSmallVolume = unit => {
    if (unit === 2) {
        return 100
    }

    if (unit === 3) {
        return 25
    }

    return 1
}

const unitLargeVolume = unit => {
    if (unit === 2) {
        return 5000
    }

    if (unit === 3) {
        return 100
    }

    return 10
}

export default {
    components: {
        TheModal,
        VolumeInput,
        VmLoadingLevel
    },

    filters: {
        unitSmallVolume(unit) {
            return unitSmallVolume(unit)
        },

        unitLargeVolume(unit) {
            return unitLargeVolume(unit)
        },

        roundVolume(volume) {
            return volume >= 1000 ? round(volume / 1000, 2) + 'K' : volume
        }
    },

    props: {
        item: {
            type: Object,
            default: _ => ({ })
        }
    },

    data() {
        return {
            add: this.item.add || 0
        }
    },

    methods: {
        subMax() {
            this.add = -1 * this.item.current_loading
        },

        subSmall() {
            const min = -1 * this.item.current_loading
            this.add = Math.max(this.add - unitSmallVolume(this.item.unit), min)
        },

        addSmall() {
            const max = this.item.max - this.item.current_loading
            this.add = Math.min(this.add + unitSmallVolume(this.item.unit), max)
        },

        addLarge() {
            const max = this.item.max - this.item.current_loading
            this.add = Math.min(this.add + unitLargeVolume(this.item.unit), max)
        },

        addMax() {
            this.add = this.item.max - this.item.current_loading
        },

        addManual(value) {
            if (value === '-' || value === '') {
                return
            }

            value = parseInt(value)

            const min = -1 * this.item.current_loading
            const max = this.item.max - this.item.current_loading

            if (value < min) {
                this.add = min
            } else if (value > max) {
                this.add = max
            } else {
                this.add = value
            }
        },

        submit() {
            this.$emit('change', [ this.item, this.add ])
            this.$emit('close')
        }
    }
}
</script>
